__turbopack_context__.v({
  "className": "inter_a9273372-module__R1Y8Sq__className",
});
